const f = {
  color: {
    default: {
      background: "#ffffffff",
      border: "#c8d3deff",
      text: "#314351ff"
    }
  },
  hover: {
    default: "#f9fafaff",
    red: "#fedfd5ff",
    green: "#e0fcdeff",
    yellow: "#ffeeccff",
    blue: "#d1e8ffff"
  },
  pill: {
    default: "#dfe6ebff",
    blue: "#ACE3FF",
    green: "#BCF1CA",
    red: "#FFAFB1",
    yellow: "#FFE258"
  }
};
export {
  f as chip
};
